import { IndicatorData } from "src/app/ui/models/domains/pbm/indicators/indicator-data";

export function parseIdicatorData(payload: any): IndicatorData[] {
  return payload.Items.map((item) => {
    return new IndicatorData(
      item.Key,
      !Array.isArray(item.Value)
        ? item.Value
        : item.Value.map((i) => {
            if (Array.isArray(i)) {
              const indicatorData = new Array<IndicatorData>();
              i.forEach((value) => {
                indicatorData.push(new IndicatorData(value.Key, value.Value));
              });
              return indicatorData;
            } else {
              return new IndicatorData(i.Key, i.Value);
            }
          }),
    );
  });
}
